import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CpuIcon, CircuitBoardIcon, HardDriveIcon } from 'lucide-react';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function CompetitionSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-142">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-143">
        <span className="text-base text-[#00d4ff] font-semibold tracking-widest uppercase" data-id="element-144">
          08
        </span>
        <span className="w-8 h-[1px] bg-[#00d4ff] opacity-50" data-id="element-145" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-3" data-id="element-146">
        Competition / Why We Win
      </motion.h2>

      <motion.div variants={fadeUp} className="mb-8" data-id="element-147">
        <p className="text-2xl text-[#00d4ff] font-semibold" data-id="element-148">
          The first FPGA inference gateway.
        </p>
        <p className="text-2xl text-[#ff6b35] font-semibold mt-1" data-id="element-149">
          1st mover advantage.
        </p>
      </motion.div>

      <motion.p variants={fadeUp} className="text-base text-[#8899aa] uppercase tracking-widest font-semibold mb-4" data-id="element-150">
        Non-competition
      </motion.p>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-151">
        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-152">
          <div className="w-10 h-10 rounded-lg bg-[rgba(255,107,53,0.1)] flex items-center justify-center mb-4" data-id="element-153">
            <CpuIcon className="w-5 h-5 text-[#ff6b35]" data-id="element-154" />
          </div>
          <p className="text-xl font-bold text-white mb-2" data-id="element-155">
            GPU Inference Gateways & Cloud Providers
          </p>
          <p className="text-[17px] text-white/70 leading-relaxed flex-1" data-id="element-156">
            More costly, slower, less deterministic inference by architecture
          </p>
          <div className="mt-3 flex gap-1" data-id="element-157">
            <span className="px-2 py-0.5 rounded text-base bg-[rgba(255,107,53,0.15)] text-[#ff6b35]" data-id="element-158">
              Costly
            </span>
            <span className="px-2 py-0.5 rounded text-base bg-[rgba(255,107,53,0.15)] text-[#ff6b35]" data-id="element-159">
              Slower
            </span>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-160">
          <div className="w-10 h-10 rounded-lg bg-[rgba(255,255,255,0.05)] flex items-center justify-center mb-4" data-id="element-161">
            <CircuitBoardIcon className="w-5 h-5 text-[#8899aa]" data-id="element-162" />
          </div>
          <p className="text-xl font-bold text-white mb-2" data-id="element-163">FPGA Vendors</p>
          <p className="text-base text-[#8899aa] mb-2" data-id="element-164">
            AMD, Intel, Achronix, Bittware
          </p>
          <p className="text-[17px] text-white/70 leading-relaxed flex-1" data-id="element-165">
            Hardware-first, complex toolchains, none cloud-native (key partners)
          </p>
          <div className="mt-3 flex gap-1" data-id="element-166">
            <span className="px-2 py-0.5 rounded text-base bg-[rgba(255,255,255,0.08)] text-[#8899aa]" data-id="element-167">
              Complex
            </span>
            <span className="px-2 py-0.5 rounded text-base bg-[rgba(0,212,255,0.15)] text-[#00d4ff]" data-id="element-168">
              Partners
            </span>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-169">
          <div className="w-10 h-10 rounded-lg bg-[rgba(255,255,255,0.05)] flex items-center justify-center mb-4" data-id="element-170">
            <HardDriveIcon className="w-5 h-5 text-[#8899aa]" data-id="element-171" />
          </div>
          <p className="text-xl font-bold text-white mb-2" data-id="element-172">Custom ASICs</p>
          <p className="text-[17px] text-white/70 leading-relaxed flex-1" data-id="element-173">
            Long design cycles, high NRE cost, can't update after deployment
          </p>
          <div className="mt-3 flex gap-1" data-id="element-174">
            <span className="px-2 py-0.5 rounded text-base bg-[rgba(255,255,255,0.08)] text-[#8899aa]" data-id="element-175">
              Slow
            </span>
            <span className="px-2 py-0.5 rounded text-base bg-[rgba(255,255,255,0.08)] text-[#8899aa]" data-id="element-176">
              Rigid
            </span>
          </div>
        </motion.div>
      </div>

      {/* OpenFPGA advantage bar */}
      <motion.div variants={fadeUp} className="mt-5 glass-card p-4 flex items-center gap-3 glow-cyan border-l-2 border-l-[#00d4ff]" data-id="element-177">
        <ShieldCheckIcon className="w-5 h-5 text-[#00d4ff] flex-shrink-0" data-id="element-178" />
        <p className="text-xl text-white/90 font-medium" data-id="element-179">
          <span className="text-[#00d4ff]" data-id="element-180">OpenFPGA:</span> Cloud-native, simple
          API, elastic scaling, no hardware hassle — none of the above offer
          this.
        </p>
      </motion.div>
    </motion.div>;
}